import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {memoize} from 'decko';
import {map} from 'rxjs/operators/map';
import {mergeMap, toArray} from 'rxjs/operators';
import {from} from 'rxjs/observable/from';
import {saveAs} from 'file-saver/FileSaver';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';

import {DataChangesObserver, TitleService} from '@common-lib';
import {ConfigurationService, VariantsService} from '../../pages-services';
import {ConfigurationBaseComponent} from '../configuration-base/configuration-base.component';
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";

@Component({
    selector: 'app-configuration-subcategories',
    templateUrl: './configuration-subcategories.component.html',
    styleUrls: ['../configuration-base/configuration-base.component.scss', '../configuration-subcategories/configuration-subcategories.component.scss'],
})

export class ConfigurationSubcategoriesComponent extends ConfigurationBaseComponent implements OnInit {
    resource = 'subcategory';

    variants = [];
    products = [];
    categories = [];

    variantsById = [];
    productsById = [];
    categoryById = [];
    subcategoryById = [];

    choices = [
        {name: 'Muiltichoice', id: true},
        {name: 'Singlechoice', id: false},
    ];

    constructor(protected title: TitleService,
                protected route: ActivatedRoute,
                protected toasterService: ToasterService,
                protected dataChanges: DataChangesObserver,
                protected translateService: TranslateService,
                protected configurationService: ConfigurationService,
                private variantsService: VariantsService) {
        super(title, route, toasterService, dataChanges, translateService, configurationService);
    }

    ngOnInit() {
        this.variantsService.getList(this.selectedLocale)
            .pipe(
                mergeMap(({variants}) => from(variants)),
                mergeMap((variant: any) => {
                    if (variant.title) {
                        return this.translateService.get(variant.title).pipe(map(title => {
                                variant.title = title;
                                return variant;
                            }),
                        )
                    }else{
                        return new Promise((resolve) => resolve(variant));
                    }
                }),
                toArray(),
            ).subscribe(variants => {
            this.variants = variants;
            this.variants.forEach(variant => {
                const {id, name, title, products} = variant;
                this.variantsById[id] = {id, name, title, products};
            });
        });

        this.configurationService.getList('products', this.selectedLocale).subscribe(({result: {products}}) => {
            products.forEach(product => {
                this.productsById[product.id] = product.title;
            });
            this.products = products;
        });

        this.configurationService.getList('categories', this.selectedLocale).subscribe(({result: {categories}}) => {
            categories.forEach(category => {
                const {title, productId, id} = category;
                this.categoryById[id] = {title, productId};
            });

            this.categories = categories;
        });

        this.loadItems();
    }

    protected loadItems(): Promise<Object> {
        const resource = 'subcategories';
        return new Promise((resolve, reject) => {
            this.configurationService.getList(resource, this.selectedLocale).subscribe(({result}) => {
                result.subcategories = result.subcategories.map(subcategory => {
                    const {name, productId, id} = subcategory;
                    this.subcategoryById[id] = {name, productId};
                    subcategory.linkedFromChecked = subcategory.linkedFromId !== null;
                    return subcategory;
                });
                this.state.items = this.createChangesObservation(result.subcategories);
                resolve(this.state.items);
            }, error => reject(error));
        });
    }

    @memoize()
    getVariantsDropdownList(subcategoryId) {
        return this.variants.filter(item => item.subcategoryId === subcategoryId || !item.subcategoryId);
    }

    onChangeCategory(event, subcategoryItem) {
        // TODO:
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/configuration-subcategories/configuration-subcategories.component.ts